<div *ngIf="modalData.name === 'createProjectActivity'">
<div class="row">
  <div class="col-md-10">

    <!-- <label class="the_select">Select Project Name</label> -->
    <mat-form-field class="full-width-fiel" >
      <mat-label>Select Project Name</mat-label>

      <mat-select (selectionChange)="selectProject($event.value)" >
        <mat-option>-- None --</mat-option>
          <mat-option *ngFor="let project of (selectedProjects | async)" [value]="project">
            {{project.ProjectTitle}}
          </mat-option>

      </mat-select>
    </mat-form-field>
  </div>

<div class="col-md-2">
  <span  id="modal-cancel-button" (click)="closeModal()" style="cursor: pointer;">
    <mat-icon class="example-tab-icon close" style="font-size: 28px !important;">close</mat-icon>
  </span>
</div>

</div>

        <div class="main"  >




          <div class="reference_activity_table" *ngIf="projectStatus">
            <div class="top">
              <button class="top_button" (click)="addProjectActivity()">
                Add<em class="ti-plus"></em> 
              </button>

              <div class="right_part">

              </div>
            </div>

            <div class="custom_table">
              <form [formGroup]="projectActivityForm">
                <div class="thead">
                  <span class="head">S/N</span>
                  <span class="head">Activity Name</span>
                  <span class="head">Activity Description</span>
                  <span class="head">Action</span>
                </div>

                <div class="tbody" formArrayName="ProjectActivities">
                  <div
                    class="td"
                    *ngFor="
                      let projectActivity of projectActivityForm.get('ProjectActivities')['controls'];
                      index as i
                    "
                    [formGroupName]="i"
                  >
                    <span class="head">{{ i + 1 }}</span>
                    <span
                      ><input
                        type="text"
                        formControlName="ProjectActivityName"
                        placeholder="Enter Project Activity Name"
                    /></span>
                    <span
                      ><input
                        type="text"
                        formControlName="ProjectActivityDescription"
                        placeholder="Enter Project Activity Description"
                    /></span>





                    <span
                      ><button
                        class="delete_icon trash"
                        (click)="deleteProjectActivity(i, projectActivity.value)"
                      >
                        <em class="ti-trash"> </em> </button
                    ></span>
                  </div>
                </div>
<!-- <pre>{{projectActivityForm.value | json}}</pre> -->
                <div class="submit">
                  <button class="submit_button" (click)="onSubmitProjectActivity(projectActivityForm.value)">
                    Submit
                  </button>

                </div>
              </form>
            </div>
          </div>
        </div>

      </div>

      <div class="container mt-5" *ngIf="modalData.name === 'createProjectPayment'">
        <div class="row">
          <div class="col-md-10">

          </div>

        <div class="col-md-2">
          <span  id="modal-cancel-button" (click)="closeModal()" style="cursor: pointer;">
            <mat-icon class="example-tab-icon close" style="font-size: 28px !important;">close</mat-icon>
          </span>
        </div>

        </div>

        <div class="row">
          <div class="col-md-12">
            <h4>Add New Project Payment</h4>
          </div>
        </div>
        <form [formGroup]="projectPaymentForm">

         <div class="row mt-5">

           <div class="col-md-6">
             <mat-form-field class="full-width-field" id="id_number">

               <input type="number" matInput placeholder="Enter Amount" formControlName="Amount" >

               <mat-error *ngIf="errorPaymentHandling('Amount', 'required')">
                You must provide <strong>amount</strong>
             </mat-error>
            </mat-form-field>
           </div>

            <div class="col-md-6">
             <mat-form-field class="full-width-field" id="id_number">

               <input matInput placeholder="Enter Invoice Number"  formControlName="InvoiceNo">

               <mat-error *ngIf="errorPaymentHandling('InvoiceNo', 'required')">
                You must provide <strong>invoice number</strong>
             </mat-error>

            </mat-form-field>
           </div>


         </div>

         <div class="row">

              <div class="col-md-6">
              <mat-form-field class="full-width-field" id="id_number" >
                <mat-select placeholder="Select Currency" formControlName="CurrencyId">
                  <mat-option>-- None --</mat-option>
                    <mat-option *ngFor="let currency of modalData.currencies" [value]="currency.id">
                      {{currency.CurrencyName}}
                    </mat-option>

                </mat-select>
              </mat-form-field>
            </div>


          <div class="col-md-6">
            <mat-form-field class="full-width-field" id="id_number">

              <input matInput [matDatepicker]="picker" formControlName="PaymentDate" placeholder="Payment Date">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <mat-hint></mat-hint>

                         <mat-error *ngIf="errorPaymentHandling('PaymentDate', 'required')">
                            You must provide <strong>date paid</strong>
                         </mat-error>
                      </mat-form-field>
          </div>
         </div>

         <div class="row">
            <div class="col-md-6">
             <mat-form-field class="full-width-field" id="id_number" >
               <mat-label>Enter Payment Description</mat-label>
                <textarea matInput rows="5" formControlName="PaymentDescription"></textarea>

                <mat-error *ngIf="errorPaymentHandling('PaymentDescription', 'required')">
                   You must provide <strong>payment description</strong>
                </mat-error>
             </mat-form-field>
           </div>

           <div class="col-md-6">
            <mat-form-field class="full-width-field" id="id_number" >
              <mat-select placeholder="Select Beneficiary" formControlName="BeneficiaryId">
                <mat-option>-- None --</mat-option>
                  <mat-option *ngFor="let bankDetail of modalData.bankDetails" [value]="bankDetail.id">
                    {{bankDetail.BeneficiaryAccountName}}
                  </mat-option>

              </mat-select>
            </mat-form-field>
           </div>
         </div>
<!-- <pre>{{projectPaymentForm.value | json}}</pre> -->


        <div class="row justify-content-center mt-5">
          <div class="col-md-12">


             <mat-dialog-actions align="center">
              <button mat-raised-button  id="modal-cancel-button" (click)="openBankDetail()">
                Add Beneficiary Bank Account
            </button>
               <button mat-raised-button id="modal-action-button" color="primary" [disabled]="projectPaymentForm.invalid" (click)="onSubmit(projectPaymentForm.value)">
                 Submit
             </button>



             </mat-dialog-actions>
          </div>
        </div>
       </form>
       </div>


         <div  *ngIf="modalData.name === 'selectOptions'">
           <div class="col-md-12">
            <h3 >Filter projects</h3>
           </div>
           <form [formGroup]="selectOptionForm">
            <div class="col-md-12">
              <mat-form-field class="full-width-field" id="id_number">
                <mat-label>Select Project Category</mat-label>
                <mat-select (selectionChange)="selectProjectType($event)" formControlName="GMOUTypeId">
                  <mat-option>-- None --</mat-option>
                  <mat-optgroup *ngFor="let projectCategory of modalData.projectCategories" [label]="projectCategory.ProjectCategoryName"
                                >
                    <mat-option *ngFor="let projectType of projectCategory.projectTypes" [value]="projectType.id">
                      {{projectType.ProjectTypeName}}
                    </mat-option>
                  </mat-optgroup>
                </mat-select>
              </mat-form-field>
          </div>
          <div class="col-md-12">
              <mat-form-field class="full-width-field" id="id_number">
                <mat-label>Select GMOU Name</mat-label>
                <mat-select (selectionChange)="selectProjectMonitorGMOU($event.value)" formControlName="GMOUId">
                  <mat-option>-- None --</mat-option>
                    <mat-option *ngFor="let gmou of selectedGmous" [value]="gmou.id">
                      {{gmou.GMOUTitle}}
                    </mat-option>

                </mat-select>
              </mat-form-field>
          </div>

          <div class="col-md-12">
            <mat-form-field class="full-width-field"  id="id_number">
              <mat-label>Select Project Name</mat-label>
              <mat-select (selectionChange)="filterProjectMonitor($event.value)" formControlName="ProjectId">
                <mat-option>-- None --</mat-option>
                  <mat-option *ngFor="let project of selectedMonitorProject" [value]="project.id">
                    {{project.ProjectTitle}}
                  </mat-option>

              </mat-select>
            </mat-form-field>
        </div>

           </form>

           <div class="row mt-4">
            <div class="col-md-12">
              <mat-dialog-actions align="center">

              <button mat-raised-button color="primary"  id="modal-cancel-button" (click)="closeModal()">
                  Close
              </button>
              </mat-dialog-actions>


            </div>
          </div>
         </div>


         <div  *ngIf="modalData.name === 'reportSelectOptions'">
          <div class="col-md-12">
           <h3 >Filter projects</h3>
          </div>

           <div class="col-md-12">
             <mat-form-field class="full-width-field" id="id_number">
               <mat-label>Select Project Category</mat-label>
               <mat-select (selectionChange)="selectProjectType($event)">
                 <mat-option>-- None --</mat-option>
                 <mat-optgroup *ngFor="let projectCategory of modalData.projectCategories" [label]="projectCategory.ProjectCategoryName"
                               >
                   <mat-option *ngFor="let projectType of projectCategory.projectTypes" [value]="projectType.id">
                     {{projectType.ProjectTypeName}}
                   </mat-option>
                 </mat-optgroup>
               </mat-select>
             </mat-form-field>
         </div>
         <div class="col-md-12">
             <mat-form-field class="full-width-field" id="id_number">
               <mat-label>Select GMOU Name</mat-label>
               <mat-select (selectionChange)="selectProjectGMOUReport($event.value)" >
                 <mat-option>-- None --</mat-option>
                   <mat-option *ngFor="let gmou of selectedGmous" [value]="gmou.id">
                     {{gmou.GMOUTitle}}
                   </mat-option>

               </mat-select>
             </mat-form-field>
         </div>



          <div class="row mt-4">
           <div class="col-md-12">
             <mat-dialog-actions align="center">

             <button mat-raised-button color="primary"  id="modal-cancel-button" (click)="closeModal()">
                 Close
             </button>
             </mat-dialog-actions>


           </div>
         </div>
        </div>

         <div class="container " *ngIf="modalData.name === 'createProjectHistory'">
          <div class="row">
            <div class="col-md-10">

            </div>

          <div class="col-md-2">
            <span  id="modal-cancel-button" (click)="closeModal()" style="cursor: pointer;">
              <mat-icon class="example-tab-icon close" style="font-size: 28px !important;">close</mat-icon>
            </span>
          </div>

          </div>

          <div class="row">
            <div class="col-md-12">
              <h4><mat-icon class="example-tab-icon">add</mat-icon> Register New Project Report</h4>
            </div>
          </div>
          <form [formGroup]="projectReportHistoryForm">

           <div class="row mt-4">

              <div class="col-md-12">
               <mat-form-field class="full-width-field" id="id_number">

                 <input matInput placeholder="Enter The Progress Report Title"  formControlName="ReportTitle">

                 <mat-error *ngIf="errorHistoryHandling('ReportTitle', 'required')">
                  You must provide <strong>invoice number</strong>
               </mat-error>

              </mat-form-field>
             </div>


           </div>


           <div class="row">
              <div class="col-md-12">
               <mat-form-field class="full-width-field" id="id_number" >
                 <mat-label>Enter The Progress Report Description</mat-label>
                  <textarea matInput rows="3" formControlName="ProgressReportDescription"></textarea>

                  <mat-error *ngIf="errorHistoryHandling('ProgressReportDescription', 'required')">
                     You must provide <strong>The Progress Report description</strong>
                  </mat-error>
               </mat-form-field>
             </div>
           </div>

  <!-- <pre>{{projectReportHistoryForm.value | json}}</pre> -->

         </form>
         <div class="man"  >

          <div class="reference_report_table" >
            <div class="row mt-4">
              <div class="col-md-12">
                <h4><mat-icon class="example-tab-icon">history</mat-icon> Project Progress History</h4>
              </div>
            </div>
            <div class="custom_table">
              <form [formGroup]="projectReportActivityForm">
                <div class="thead">
                  <span class="head text-center">S/N</span>
                  <span class="head text-center">Activity Name</span>
                  <span class="head text-center">Slider Input</span>
                  <span class="head text-center">% Complete</span>
                  <span class="head text-center">Note</span>
                </div>

                <div class="tbody" formArrayName="ProgressActivities">
                  <div
                    class="td"
                    *ngFor="
                      let projectActivity of projectReportActivityForm.get('ProgressActivities')['controls'];
                      index as i
                    "
                    [formGroupName]="i"
                  >
                    <span class="head">{{ i + 1 }}</span>
                    <span
                      >{{projectActivity.value.ProjectActivityName}}</span>

                      <span>
                        <mat-slider
                        class="full-width-fields"
                        [invert]="invert"
                        [max]="max"
                        [min]="min"
                        [step]="step"
                        [thumbLabel]="thumbLabel"
                        (input)="getSliderTickInterval($event.value, i)"
                        formControlName="ProjectActivityProgress"
                        [vertical]="vertical">
                    </mat-slider>
                      </span>
                      <span class="text-center" *ngIf="projectActivity.value.ProjectActivityReport > 0; else noShow">{{projectActivity.value.ProjectActivityReport}}%</span>
                      <ng-template #noShow>
                        <span></span>
                      </ng-template>
                    <span
                      ><input type="text" formControlName="ReportNote" class="full-width-fields" placeholder="Enter Note"></span>
                  </div>
                </div>
<!-- <pre>{{projectReportActivityForm.value | json}}</pre> -->
              </form>

              <mat-dialog-actions align="center">

                <button mat-raised-button id="modal-action-button" class="mt-4" color="primary" (click)="onSubmitReportHistory()">
                  Submit
              </button>

              <!-- <button mat-raised-button  id="modal-cancel-button" (click)="closeModal()">
                  Go back
              </button> -->

              </mat-dialog-actions>
            </div>
          </div>
        </div>


         </div>


         <div class="container " *ngIf="modalData.name === 'createProjectMeeting'">
          <div class="row">
            <div class="col-md-10">

            </div>

          <div class="col-md-2">
            <span  id="modal-cancel-button" (click)="closeModal()" style="cursor: pointer;">
              <mat-icon class="example-tab-icon close" style="font-size: 28px !important;">close</mat-icon>
            </span>
          </div>

          </div>

          <div class="row">
            <div class="col-md-12">
              <h4><mat-icon class="example-tab-icon">add</mat-icon> Register New Meeting Report</h4>
            </div>
          </div>
          <form [formGroup]="projectReportMeetingForm">

           <div class="row mt-5">

              <div class="col-md-12">
               <mat-form-field class="full-width-field" id="id_number">

                 <input matInput placeholder="Enter The Meeting Report Title"  formControlName="MeetingReportTitle">

                 <mat-error *ngIf="errorMeetingHandling('MeetingReportTitle', 'required')">
                  You must provide <strong>The Meeting Report Title</strong>
               </mat-error>

              </mat-form-field>
             </div>


           </div>


           <div class="row mt-4">
              <div class="col-md-12">
               <mat-form-field class="full-width-field" id="id_number" >
                 <mat-label>Enter The Meeting Report Description</mat-label>
                  <textarea matInput rows="5" formControlName="MeetingReportDescription"></textarea>

                  <mat-error *ngIf="errorMeetingHandling('MeetingReportDescription', 'required')">
                     You must provide <strong>The Meeting Report Description</strong>
                  </mat-error>
               </mat-form-field>
             </div>
           </div>

  <!-- <pre>{{projectReportHistoryForm.value | json}}</pre> -->
  <div class="row justify-content-center mt-5">
    <div class="col-md-12">


       <mat-dialog-actions align="center">

         <button mat-raised-button id="modal-action-button" color="primary"
         (click)="onSubmitReportMeeting(projectReportMeetingForm.value)" [disabled]="projectReportMeetingForm.invalid">
           Submit
       </button>

       <!-- <button mat-raised-button  id="modal-cancel-button the__cancel" (click)="closeModal()">
           Go back
       </button> -->

       </mat-dialog-actions>
    </div>
  </div>
         </form>
         </div>


         <div class="container customize" *ngIf="modalData.name === 'viewProjectMeeting'">
          <div class="row">
            <div class="col-md-10">

            </div>

          <div class="col-md-2">
            <span  id="modal-cancel-button" (click)="closeModal()" style="cursor: pointer;">
              <mat-icon class="example-tab-icon close" style="font-size: 28px !important;">close</mat-icon>
            </span>
          </div>

          </div>
           <div class="row">
             <div class="col-md-12">
               <h3 class="the__heading">Meeting Report As At {{modalData.meetingReport.DateReported | date:'M/d/yyyy'}}</h3>
               <h5 class="the_title">Title
                <span class="the__main-title">{{modalData.meetingReport.MeetingReportTitle}}</span>
              </h5>
               <!-- <h5 class="mt-4 the_title">Title</h5>
               <p style="font-size: 15px;">{{modalData.meetingReport.MeetingReportTitle}}</p> -->
             </div>
            </div>
            <div class="row mt-5">
              <div class="col-md-12">
                <h4>Description</h4>
               <p class="the___description"> {{modalData.meetingReport.MeetingReportDescription}}</p>

              </div>
            </div>




         </div>


         <div class="container customize" *ngIf="modalData.name === 'viewProjectMaster'">
          <div class="row">
            <div class="col-md-10">

            </div>

          <div class="col-md-2">
            <span  id="modal-cancel-button" (click)="closeModal()" style="cursor: pointer;">
              <mat-icon class="example-tab-icon close" style="font-size: 28px !important;">close</mat-icon>
            </span>
          </div>

          </div>
          <div class="row">
            <div class="col-md-12">
              <h3 class="the__heading">Meeting report as at {{modalData.masterReport.DateReported | date:'M/d/yyyy'}}</h3>
              <h5 class="the_title">Title
                <span class="the__main-title">{{modalData.masterReport.ReportTitle}}</span>
              </h5>

              <h4>Description</h4>
              <p class="the___description"> {{modalData.masterReport.ProgressReportDescription}}</p>

            </div>
          </div>
          <div class="row">
            <h4>Project Activity Progress</h4>
            <div class="col-md-12">
            <div *ngFor="let history of modalData.selectedReportHistories" >


                  <div style="margin-top: 25px;">{{history.ProjectActivityName}}</div>
                  <mat-progress-bar mode="determinate" [value]="history.ProjectActivityProgress" style="margin-top: 10px;"></mat-progress-bar>

             </div>

             <div class="row" style="margin-top: 25px;">
               <div class="col-md-12">
                 <span>Overall Project Progress</span>
                <mat-progress-bar mode="determinate"  [value]="totalProjectActivityProgress" style="margin-top: 10px;"></mat-progress-bar>

               </div>
             </div>
            </div>
          </div>



        </div>



<div class="container" *ngIf="modalData.name === 'viewBudgetPayment'">
          <div class="row">
            <div class="col-md-10">

            </div>

          <div class="col-md-2">
            <span  id="modal-cancel-button" (click)="closeModal()" style="cursor: pointer;">
              <mat-icon class="example-tab-icon close" style="font-size: 28px !important;">close</mat-icon>
            </span>
          </div>

          </div>
    <!-- Amount: value.Amount,
          InvoiceNo: value.InvoiceNo,
          ProjectId: value.ProjectId,
          PaymentDescription: value.PaymentDescription,
          PaymentDate: value.PaymentDate -->
          <div class="row">
            <div class="col-md-12">
              <h3 class="heading">Payment Information</h3>
              <div class="the_info row">
                <h5 class="main__info col-md-4 mb-4">
                  <span class="label d-block">Beneficiary Name</span>
                  <span class="info d-block">{{modalData.bankDetail.BeneficiaryAccountName}}</span>
                </h5>
                <h5 class="main__info col-md-4 mb-4">
                  <span class="label d-block">Amount Paid</span>
                  <span class="info d-block">{{modalData.selectedProjectPayment.Amount | currency:getCurrencyName(modalData.selectedProjectPayment?.CurrencyId):'symbol-narrow'}}</span>
                </h5>
                <h5 class="main__info col-md-4 mb-4">
                  <span class="label d-block">Beneficiary Account No.</span>
                  <span class="info d-block">{{modalData.bankDetail.BeneficiaryAccountNumber}}</span>
                </h5>
                <h5 class="main__info col-md-4 mb-4">
                  <span class="label d-block">Bank Name</span>
                  <span class="info d-block">{{getBankName(modalData.bankDetail.BankName)}}</span>
                </h5>
                <h5 class="main__info col-md-4 mb-4">
                  <span class="label d-block">Branch</span>
                  <span class="info d-block">{{modalData.bankDetail.Branch}}</span>
                </h5>

                <h5 class="main__info col-md-4 mb-4">
                  <span class="label d-block">Date Paid</span>
                  <span class="info d-block">{{modalData.selectedProjectPayment.PaymentDate | date}}</span>
                </h5>
                <h5 class="main__info col-md-4 mb-4">
                  <span class="label d-block">Invoice No.</span>
                  <span class="info d-block">{{modalData.selectedProjectPayment.InvoiceNo}}</span>
                </h5>
                <h5 class="main__info col-md-4 mb-4">
                  <span class="label d-block">payment Description</span>
                  <span class="info d-block">{{modalData.selectedProjectPayment.PaymentDescription}}</span>
                </h5>

              </div>

            </div>
          </div>


        </div>
